module.exports = "/images/postes.svg?7562cfc104face7ce4ba35e5ef0933e6";